import { FC } from "react";
import { Datagrid, List, TextField } from "react-admin";

import CustomPagination from "../../../components/CustomPagination";
import EmptyDataText from "../../../components/EmptyDataText";
import ShowFullTextOnHover from "../../../components/ShowFullTextOnHover";
import TimestampField from "../../../components/TimestampField";
import useCurrentUser from "../../../hooks/useCurrentUser";
import useIsAdmin from "../../../hooks/useIsAdmin";
import useUpdateListNotifications from "../../../hooks/useUpdateListNotifications";
import { AppResource } from "../../../types/resource.types";
import { gymDocRef } from "../../../utils/referencies";
import DeleteReview from "./components/DeleteReview";
import CommentsFilters from "./components/Filters";
import ReviewerListTitle from "./components/ReviewerListTitle";
import ReviewsListTitle from "./components/ReviewsListTitle";

const GymsReviewsList: FC<any> = (props) => {
  const { isAdmin } = useIsAdmin();

  const { user } = useCurrentUser();

  useUpdateListNotifications(gymDocRef(user.id as string), AppResource.gymReviews, AppResource.reviewsLastSeenAt);

  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      filters={<CommentsFilters />}
      exporter={false}
      bulkActionButtons={false}
    >
      <Datagrid empty={<EmptyDataText message="No reviews yet!" />}>
        {isAdmin && <ReviewsListTitle label="Gym" />}
        <ReviewerListTitle label="Reviewer" />
        <ShowFullTextOnHover source="review" label="Review" sortable={false} />
        <TextField source="rate" label="Rate" sortable={false} />
        <TimestampField source="createdAt" label="Created At" />
        {isAdmin && <DeleteReview />}
      </Datagrid>
    </List>
  );
};

export default GymsReviewsList;
